import script from "./bonusomat-quest-award-icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./bonusomat-quest-award-icon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__